module.exports = __webpack_public_path__ + "static/media/sms.48e8d03c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sms.svg
// module id = 250
// module chunks = 1